import React, { useEffect, useRef } from 'react';

// INITIAL PEEL AT A FIXED ANGLE

export default function Sticker({ 
  mode = "emoji",
  src, 
  size = 400, 
  radius = 120, 
  width = null,
  height = null,
  emojis = ['🏀', '⚽', '🤜🤛', '👻'],
  images = ['/assets/html.png', '/assets/css.png', '/assets/js.png'],
  // bg = "#fcfcfc",
  bg = "#fcfcfc",
  frontColor = "#03A9F4", 
  backColor = "white",
  // fraction of radius to peel initially (0 = no initial peel). e.g. 0.15 = 15% of radius
  initialPeeled = 0.7,
  onInteractionChange = () => {}, // Callback when interaction starts/stops
}) {
  const containerRef = useRef(null);
  const p5InstanceRef = useRef(null);
  const isInteractingRef = useRef(false);

  let emojiIndex = 0;
  let imageIndex = 0;

  useEffect(() => {
    let mounted = true;
    let canvasElement = null;

    // Dynamically import p5
    import('https://cdnjs.cloudflare.com/ajax/libs/p5.js/1.4.0/p5.min.js').then(() => {
      if (!mounted) return; // Don't create if component unmounted during import

    let r = radius;
    let cx, cy;
    const initialFixedAngle = 90 + 40;
    let isFirstHover = true;
    let fixedAngle = initialPeeled > 0 ? initialFixedAngle : null;
    let trajectory = initialPeeled > 0 ? initialPeeled * r : 0;
    let bb, g, shadowG;
    let g2;
    let isPeeling = false;
    let peeledImage;

      const sketch = (p) => {
        p.preload = () => {
          bb = p.loadImage(src);
          if (mode === "image") {
            peeledImage = p.loadImage(images[emojiIndex % images.length]);
          }
        };

        p.setup = () => {
          p.createCanvas(400, 400);
          p.angleMode(p.DEGREES);
          p.noStroke();

          cx = p.width / 2;
          cy = p.height / 2;

          g = p.createGraphics(p.width, p.height);
          g.angleMode(p.DEGREES);
          // g.background('red');
          // g.clear();

          // secondary graphics for overlays (text/marks visible when peeled)
          g2 = p.createGraphics(p.width, p.height);
          g2.angleMode(p.DEGREES);
          g2.clear();

          shadowG = p.createGraphics(p.width, p.height);
          shadowG.background('red');
        };

        p.draw = () => {
          p.background(bg);
          // p.clear();
          shadowG.clear();

          // (removed global text draw; we'll render text into g2 so it
          // appears only in the peeled/remaining area)

          // MASK STATIC CIRCLE
          g.noStroke();
          g.fill(bg);
          g.rect(0, 0, p.width, p.height);

          g.erase();
            g.circle(cx, cy, r);
          g.noErase();

          p.fill(frontColor);
          p.fill(255);
          p.stroke(0, 40);
          p.noStroke();
          p.circle(cx, cy, r);

          p.push();
            p.imageMode(p.CENTER);
            // Use width/height if provided, else fallback to r
            let imgW = r * 1;
            let imgH = r * 1;
            p.image(bb, cx, cy, imgW, imgH);
          p.pop();

          // (mask will be rendered after we compute the peeled overlays)

            // (text will be drawn into g2 later, once we know the remaining area)
          // Handle mouse entering the circle area. If we haven't set fixedAngle yet,
          // use either the initialFixedAngle for the first hover or compute from mouse.
          // Also, if we preset an initial peeled state (fixedAngle already set),
          // mark the first hover as consumed without changing the preset angle.
          let isInsideCircle = p.dist(cx, cy, p.mouseX, p.mouseY) < r / 2;
          
          if (isInsideCircle) {
            if (fixedAngle === null) {
              if (isFirstHover) {
                // Use a predetermined initial angle only for the very first hover
                fixedAngle = initialFixedAngle;
                isFirstHover = false;
              } else {
                // Afterwards compute angle from mouse position as before
                fixedAngle = p.atan2(p.mouseY - cy, p.mouseX - cx);
              }
              // Start peeling
              if (!isPeeling) {
                isPeeling = true;
                onInteractionChange(true);
              }
            } else if (isFirstHover) {
              // We had a preset initial peel (fixedAngle already set); consume the first hover
              // so subsequent interaction computes trajectory from the mouse.
              isFirstHover = false;
              if (!isPeeling) {
                isPeeling = true;
                onInteractionChange(true);
              }
            } else {
              // Continue peeling if already started
              if (!isPeeling) {
                isPeeling = true;
                onInteractionChange(true);
              }
            }
          }

          if (fixedAngle !== null) {
            if (!isFirstHover) {
              // Vector from center to mouse
              let dx = p.mouseX - cx;
              let dy = p.mouseY - cy;
              // Project mouse vector onto fixed direction
              trajectory = dx * p.cos(fixedAngle) + dy * p.sin(fixedAngle) + r / 2;
              // Mark that the user has started an interactive peel
              
            }
            // If isFirstHover is true we keep the preset `trajectory` (initial peeled state)
            // Position of the second circle along the trajectory
            let px = cx + p.cos(fixedAngle) * trajectory;
            let py = cy + p.sin(fixedAngle) * trajectory;

            // GET MASK AREA
            let transX, maskW;
            if (trajectory > 0) {
              transX = -r / 2;
              maskW = (trajectory + r) / 2;
            } else {
              transX = -r / 2 + trajectory;
              maskW = (p.abs(trajectory) + r) / 2;
            }

            // DRAW SHADOW
            let ctx = shadowG.drawingContext;
            ctx.save();
            ctx.beginPath();
            if (trajectory >= 0) {
              ctx.arc(cx, cy, r / 2, 0, p.TWO_PI);
            } else {
              ctx.arc(px, py, r / 2, 0, p.TWO_PI);
            }
            ctx.clip();
            ctx.translate(cx, cy);
            ctx.rotate(p.radians(fixedAngle));
            let gradient = ctx.createLinearGradient(transX + maskW, 0, transX, 0);
            gradient.addColorStop(0, 'rgba(0,0,0,0.3)');
            gradient.addColorStop(0.1, 'rgba(0,0,0,0.1)');
            gradient.addColorStop(0.4, 'rgba(0,0,0,0)');
            ctx.fillStyle = gradient;
            ctx.fillRect(transX, -r / 2, maskW, r);
            ctx.restore();

            // DRAW SECOND CIRCLE
            p.fill(backColor);
            p.stroke(0, 10);
            p.circle(px, py, r);

            // MIRRORED IMAGE
            p.push();
            p.imageMode(p.CENTER);
            p.translate(px, py);
            // Limit rotation for images
            let displayAngle = fixedAngle;
            if (mode === "image") {
              // Clamp rotation for images to a smaller range (e.g., -30 to 30 degrees)
              const maxImageRotate = 0;
              displayAngle = Math.max(Math.min(fixedAngle, maxImageRotate), -maxImageRotate);
            }
            p.rotate(displayAngle * 2);
            let angle = displayAngle % 360;
            let mirrorScale = p.cos(p.radians(angle));
            p.scale(-mirrorScale, 1);
            p.tint(255, 40);
            p.image(bb, 0, 0, r, r);
            p.pop();

            p.image(shadowG, 0, 0);

            // MASK
            g.noStroke();
            g.fill(bg);
            g.rect(0, 0, p.width, p.height);

            g.erase();
              g.push();
                g.translate(cx, cy);
                g.rotate(fixedAngle);
                g.rect(transX, -r / 2, maskW, r);
              g.pop();
            g.noErase();

            // DRAW MARK/REMAINING-AREA OVERLAY (g2)
            // compute remaining area and draw text/texture into g2 clipped to it
            let remainX, remainW;

            if (trajectory > 0) {
              remainX = transX + maskW;
              remainW = r - maskW;
            } else {
              remainX = r / 2 - maskW;
              remainW = maskW;
            }

            // console.log('remainW', remainW);
            // console.log(fixedAngle)

            // DRAW EMOJI or IMAGE
            g2.clear();
            g2.push();
              g2.translate(cx, cy);
              g2.rotate(fixedAngle);
              g2.drawingContext.save();
              g2.drawingContext.beginPath();
              g2.drawingContext.rect(remainX, -r / 2, remainW, r);
              g2.drawingContext.clip();

              if (mode === "image" && peeledImage) {
                g2.rotate(-fixedAngle);
                g2.imageMode(p.CENTER);
                g2.image(peeledImage, 0, 0, r * 0.7, r * 0.7);
              } else {
                g2.fill(0);
                g2.textAlign(p.CENTER, p.CENTER);
                g2.textSize(r * 0.5);
                g2.text(emojis[emojiIndex], 0, 0);
              }

              g2.drawingContext.restore();
            g2.pop();

            p.image(g2, 0, 0);

            // RESET
            if (trajectory <= -r * 1.1 || remainW <= 0) {
              fixedAngle = null;
              g2.clear();

              emojiIndex = (emojiIndex + 1) % emojis.length;
              imageIndex = (imageIndex + 1) % images.length;

              if (mode === "image") {
                // Loop peeledImage for image mode
                peeledImage = p.loadImage(images[imageIndex % images.length]);
              }

              // Peel completed
              if (isPeeling) {
                isPeeling = false;
                onInteractionChange(false);
              }
            }
          }

          // Draw final mask and overlays: draw `g` (mask) then `g2` (text/marks) on top
          p.image(g, 0, 0);
          p.image(g2, 0, 0);
        };
      };

      // Remove any existing instance before creating new one
      if (p5InstanceRef.current) {
        p5InstanceRef.current.remove();
      }

      p5InstanceRef.current = new window.p5(sketch, containerRef.current);
      
      // Wait for canvas to be created, then attach touch handlers
      setTimeout(() => {
        if (!mounted) return;
        canvasElement = containerRef.current?.querySelector('canvas');
        
        if (canvasElement) {
          // Save scroll position to restore it
          let scrollY = 0;
          
          const preventScroll = (e) => {
            isInteractingRef.current = true;
            scrollY = window.scrollY;
            
            // Notify parent that interaction started
            onInteractionChange(true);
            
            // Prevent default immediately
            e.preventDefault();
            e.stopPropagation();
            
            return false;
          };
          
          const handleTouchMove = (e) => {
            // Always prevent when touching canvas
            e.preventDefault();
            e.stopPropagation();
            return false;
          };
          
          const stopInteracting = () => {
            isInteractingRef.current = false;
            
            // Notify parent that interaction stopped
            onInteractionChange(false);
          };
          
          // Use capture phase to catch events before p5.js
          canvasElement.addEventListener('touchstart', preventScroll, { passive: false, capture: true });
          canvasElement.addEventListener('touchmove', handleTouchMove, { passive: false, capture: true });
          canvasElement.addEventListener('touchend', stopInteracting, { passive: true });
          canvasElement.addEventListener('touchcancel', stopInteracting, { passive: true });
          
          // Set CSS properties
          canvasElement.style.touchAction = 'none';
          canvasElement.style.userSelect = 'none';
          canvasElement.style.webkitUserSelect = 'none';
        }
      }, 100);
    });

    // Cleanup function
    return () => {
      mounted = false;
      
      if (canvasElement) {
        canvasElement.style.touchAction = '';
      }

      if (p5InstanceRef.current) {
        p5InstanceRef.current.remove();
        p5InstanceRef.current = null;
      }
    };
  }, [src, size, radius, bg, frontColor, backColor, mode]);

  return <div ref={containerRef} />;
}